
const CardsIcon: React.FC = () => (
	<svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#5f6368">
		<path
			d="M140-184.62v-50.25h680v50.25H140Zm0-540.51v-50.25h680v50.25H140Zm62.57 379.85q-25.79 0-44.18-18.39T140-407.85v-144.3q0-25.79 18.39-44.18t44.18-18.39h554.86q25.79 0 44.18 18.39T820-552.15v144.3q0 25.79-18.39 44.18t-44.18 18.39H202.57Zm0-50.26h554.86q4.62 0 8.47-3.84 3.84-3.85 3.84-8.47v-144.3q0-4.62-3.84-8.47-3.85-3.84-8.47-3.84H202.57q-4.62 0-8.47 3.84-3.84 3.85-3.84 8.47v144.3q0 4.62 3.84 8.47 3.85 3.84 8.47 3.84Zm-12.31-168.92V-395.54-564.46Z"/>
	</svg>
);

export default CardsIcon;
